module.exports = __webpack_public_path__ + "img/AUD.85169fa9.png";